namespace GeniuzPOS.Purchase {
    export interface PoPurRequestDtForm {
        LineItemNo: Serenity.IntegerEditor;
        SupplierId: Serenity.LookupEditor;
        WhsId: Serenity.LookupEditor;
        ShopId: Serenity.StringEditor;
        SkuCode: Serenity.LookupEditor;
        SkuDesc: Serenity.StringEditor;
        UnitCost: Serenity.DecimalEditor;
        Qty: Serenity.DecimalEditor;
        UnitChange: Serenity.EnumEditor;
        PurUnit: Serenity.StringEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        LastPurUnitPrice: Serenity.DecimalEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        BeforeDiscAmt: Serenity.DecimalEditor;
        DiscText: Serenity.StringEditor;
        DiscAmt: Serenity.DecimalEditor;
        ItemAmt: Serenity.DecimalEditor;
        AlocalteDiscAmt: Serenity.DecimalEditor;
        ItemNetAmt: Serenity.DecimalEditor;
        VatCode: Serenity.LookupEditor;
        VatType: Serenity.StringEditor;
        VatRate: Serenity.DecimalEditor;
        ItemVatAmt: Serenity.DecimalEditor;
        ItemExVatAmt: Serenity.DecimalEditor;
        ItemNetCostValue: Serenity.DecimalEditor;
        SalesVatTypes: Serenity.LookupEditor;
    }

    export class PoPurRequestDtForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPurRequestDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoPurRequestDtForm.init)  {
                PoPurRequestDtForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.EnumEditor;

                Q.initFormType(PoPurRequestDtForm, [
                    'LineItemNo', w0,
                    'SupplierId', w1,
                    'WhsId', w1,
                    'ShopId', w2,
                    'SkuCode', w1,
                    'SkuDesc', w2,
                    'UnitCost', w3,
                    'Qty', w3,
                    'UnitChange', w4,
                    'PurUnit', w2,
                    'PurUnitPrice', w3,
                    'LastPurUnitPrice', w3,
                    'PurUnitRatio', w3,
                    'Remark', w2,
                    'BeforeDiscAmt', w3,
                    'DiscText', w2,
                    'DiscAmt', w3,
                    'ItemAmt', w3,
                    'AlocalteDiscAmt', w3,
                    'ItemNetAmt', w3,
                    'VatCode', w1,
                    'VatType', w2,
                    'VatRate', w3,
                    'ItemVatAmt', w3,
                    'ItemExVatAmt', w3,
                    'ItemNetCostValue', w3,
                    'SalesVatTypes', w1
                ]);
            }
        }
    }
}
